/* muc-q54.js — Q54-3 (D-087): al saltar de Mapa a Lectura (o de relación) con el interruptor o los chips, los datos de
   nacimiento ya escritos viajan a la ficha de destino por el canal que muc-pdp.js ya lee (sessionStorage 'muc:traspaso',
   el de la calculadora de la home). No cambia la lógica de muc-pdp.js; solo oculta su línea «Traemos tus datos de la
   calculadora», que aquí no aplica. Nunca envía datos a ningún sitio. */
(() => {
  const $ = id => document.getElementById(id);
  const personas = () => {
    const out = [];
    for (let i = 1; i <= 5; i++) {
      const nom = $('muc-n' + i); if (!nom || nom.disabled) continue;
      const fv = $('muc-f' + i + '-es'), hv = $('muc-h' + i + '-es'), cv = $('muc-c' + i + '-es');
      const oc = cv && cv.dataset.para ? $(cv.dataset.para) : null;
      const sh = document.querySelector('input[data-muc="sinhora"][data-n="' + i + '"]');
      let lugar = null; try { lugar = oc && oc.value ? JSON.parse(oc.value) : null; } catch (e) {}
      out.push({nombre: (nom.value || '').trim(), fecha: fv ? fv.value : '', hora: hv ? hv.value : '', sinHora: !!(sh && sh.checked), lugar});
    }
    return out;
  };
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[data-muc-q54-ir]'); if (!a) return;
    const ps = personas(); if (!ps.some(p => p.nombre || p.fecha || p.lugar)) return;
    try {
      const url = new URL(a.href, location.href).pathname;
      sessionStorage.setItem('muc:traspaso', JSON.stringify({url, personas: ps}));
      sessionStorage.setItem('muc:q54:ir', url);
    } catch (err) {}
  });
  document.addEventListener('DOMContentLoaded', () => {
    let ir = null; try { ir = sessionStorage.getItem('muc:q54:ir'); } catch (e) {}
    if (ir !== location.pathname) return;
    try { sessionStorage.removeItem('muc:q54:ir'); } catch (e) {}
    const l = document.querySelector('[data-muc="traspaso"]'); if (l) l.hidden = true;
  });
})();
/* ==== Q54-4 INICIO ==== */
/* ==== Q54-4 (D-089): complemento cruzado. muc-pdp.js suma MUC.q54.extra() al total y añade MUC.q54.items() al carrito
   (gancho mínimo, opción A de §7.5). Sin bloque Q54 en la página, extra() = 0 e items() = []: todo como antes. ==== */
(() => {
  const MUC = (window.MUC = window.MUC || {});
  const blq = document.querySelector('[data-muc-q54="cruzada"], [data-muc-q54="complemento"]');
  const vacio = {extra: () => 0, items: () => []};
  if (!blq) { MUC.q54 = vacio; return; }
  let D = {}; try { D = JSON.parse(blq.querySelector('script[data-muc-q54-datos]').textContent); } catch (e) { MUC.q54 = vacio; return; }
  const modo = blq.dataset.mucQ54;
  const TAM = {'30x40': '30 × 40 cm', '40x50': '40 × 50 cm', '50x70': '50 × 70 cm'};
  const eur = c => (MUC.pdp && MUC.pdp.eur) ? MUC.pdp.eur(c) : (c / 100).toFixed(2).replace('.', ',') + ' €';
  const st = {bump: false, op: 'no', tam: D.tamInicial || '50x70', marco: D.marcoInicial || 'negro'};
  const bumpBtn = blq.querySelector('[data-muc-q54-bump]');
  if (bumpBtn) st.bump = bumpBtn.getAttribute('aria-pressed') === 'true';
  /* variante del Mapa elegida en la Lectura: mismas claves que muc-pdp.js (Acabado × Tamaño) */
  const V = D.variantes || [];
  const buscar = (o1, o2) => V.find(v => v.o1 === o1 && v.o2 === o2 && v.disponible !== false) || null;
  const varMapa = (op, tam, marco) => op === 'pdf' ? (buscar('Archivo digital', 'Digital') || buscar('PDF digital', 'Digital'))
    : op === 'lamina' ? buscar('Lámina', TAM[tam]) : op === 'marco' ? buscar('Marco ' + String((D.marcos || {})[marco] || marco).toLowerCase(), TAM[tam]) : null;
  const desde = op => { const ps = (op === 'pdf' ? [varMapa('pdf')] : Object.keys(TAM).flatMap(t => op === 'lamina' ? [varMapa('lamina', t)] : ['negro', 'pino', 'blanco'].map(m => varMapa('marco', t, m)))).filter(Boolean).map(v => v.precio);
    return ps.length ? Math.min(...ps) : 0; };
  const actual = () => modo === 'cruzada' ? (st.bump ? {id: D.id, precio: D.precio} : null) : varMapa(st.op, st.tam, st.marco);
  const lineaExtra = () => modo === 'cruzada' ? D.linea
    : (D.linea || 'Mapa astral') + ' · ' + ((D.nombres || {})[st.op] || st.op) + (st.op === 'marco' ? ' ' + String((D.marcos || {})[st.marco] || '').toLowerCase() : '') + (st.op !== 'pdf' ? ' ' + TAM[st.tam] : '');
  const repintar = () => { try { MUC.pdp && MUC.pdp.pintar && MUC.pdp.pintar(); } catch (e) {} pintarQ(); };

  function pintarQ(){
    if (bumpBtn) bumpBtn.setAttribute('aria-pressed', st.bump ? 'true' : 'false');
    blq.querySelectorAll('[data-q54-centimos]').forEach(e => { e.textContent = eur(+e.dataset.q54Centimos); }); /* mismo formato que el tema: «29,99 €», «69 €» */
    blq.querySelectorAll('.muc-q54-op').forEach(b => { const op = b.dataset.op; b.setAttribute('aria-pressed', op === st.op ? 'true' : 'false');
      const pr = b.querySelector('[data-precio]'); if (pr) pr.textContent = op === 'pdf' ? '+ ' + eur(desde('pdf')) : String(D.desde || '+ desde {precio}').replace('{precio}', eur(desde(op))); });
    const fis = st.op === 'lamina' || st.op === 'marco';
    const wt = blq.querySelector('[data-q54-tam]'), wm = blq.querySelector('[data-q54-marco]');
    if (wt) wt.hidden = !fis; if (wm) wm.hidden = st.op !== 'marco';
    blq.querySelectorAll('[data-tam]').forEach(b => { b.setAttribute('aria-pressed', b.dataset.tam === st.tam ? 'true' : 'false');
      const v = varMapa(st.op === 'marco' ? 'marco' : 'lamina', b.dataset.tam, st.marco), s = b.querySelector('small'); if (s) s.textContent = v ? '+ ' + eur(v.precio) : ''; });
    blq.querySelectorAll('[data-marco]').forEach(b => b.setAttribute('aria-pressed', b.dataset.marco === st.marco ? 'true' : 'false'));
    /* resumen de 2 líneas (D-1): solo con complemento, encima del total actual */
    const tot = document.querySelector('[data-muc-bloque="total-cta"]'); if (!tot) return;
    let ul = tot.querySelector('.muc-q54-lineas');
    if (!ul){ ul = document.createElement('ul'); ul.className = 'muc-q54-lineas'; tot.insertBefore(ul, tot.firstElementChild ? tot.firstElementChild.nextSibling : null); }
    const x = actual(); ul.hidden = !x; if (!x) return;
    const P = MUC.pdp, base = P && P.base ? P.base()[0] + (P.conAddon && P.conAddon() && P.V && P.V.complemento ? P.V.complemento.precio : 0) : 0;
    const propia = modo === 'cruzada' ? (D.lineaPropia || 'Mapa astral') + ' · ' + (P && P.variante ? P.variante() : '') : (D.lineaPropia || 'Lectura astral');
    ul.innerHTML = '';
    [[propia, base], [lineaExtra(), x.precio]].forEach(([t, c]) => { const li = document.createElement('li'); const a = document.createElement('span'), b = document.createElement('span');
      a.textContent = t; b.textContent = c ? eur(c) : 'incluido'; li.append(a, b); ul.append(li); });
  }

  if (bumpBtn) bumpBtn.addEventListener('click', () => { st.bump = !st.bump; repintar(); });
  blq.addEventListener('click', e => { const b = e.target.closest('button'); if (!b || b === bumpBtn) return;
    if (b.dataset.op) st.op = b.dataset.op; else if (b.dataset.tam) st.tam = b.dataset.tam; else if (b.dataset.marco) st.marco = b.dataset.marco; else return;
    repintar(); });
  document.addEventListener('muc:pdp', e => { if (e.detail && e.detail.tipo === 'pintar') pintarQ(); });
  try { const q = new URLSearchParams(location.search).get('complemento'); if (modo === 'complemento' && ['pdf', 'lamina', 'marco'].includes(q)) st.op = q; } catch (e) {}

  MUC.q54 = {
    extra: () => { const x = actual(); return x ? x.precio : 0; },
    /* 2.ª línea con las MISMAS propiedades de nacimiento; el regalo del Mapa no pasa a la Lectura; el Mapa desde la Lectura lleva su regalo (D-10) */
    items: (props, r, PD) => { const x = actual(); if (!x) return []; PD = PD || {};
      const pr = Object.assign({}, props); delete pr._regalo; if (PD.pdf_regalo) delete pr[PD.pdf_regalo];
      if (modo === 'complemento' && (st.op === 'lamina' || st.op === 'marco') && st.tam !== '30x40' && PD.pdf_regalo)
        pr[PD.pdf_regalo] = 'Sí (' + TAM[st.tam].replace(/\s*cm$/, '') + (st.tam === '50x70' ? ' + meditación' : '') + ')' + (PD.regalo_envio || '');
      if (modo === 'complemento' && (st.op === 'lamina' || st.op === 'marco') && st.tam !== '30x40') { const g = st.tam === '50x70' ? D.regaloMed : D.regalo; if (g) pr._regalo = g; }
      return [{id: x.id, quantity: 1, properties: pr}]; },
    estado: st
  };
  pintarQ();
})();
/* ==== Q54-4 FIN ==== */
/* ==== Q54-5 INICIO ==== */
/* Q54-5 · home: selector de relación. Pulsar un chip muestra el par Mapa/Lectura de esa relación (no navega), lo guarda en
   sessionStorage ('muc:q54:rel', con try/catch) y apunta los enlaces «¿Las dos?» y «Ver qué incluye» a la Lectura de esa relación. */
(() => {
  const sec = document.querySelector('[data-muc-q54-exp]');
  const chips = sec ? [...sec.querySelectorAll('[data-q54-chip]')] : [];
  const paneles = sec ? [...sec.querySelectorAll('[data-q54-panel]')] : [];
  const ambas = sec ? sec.querySelector('[data-q54-ambas]') : null;
  const seguir = [...document.querySelectorAll('a[data-q54-seguir]')];
  if (!chips.length || !paneles.length) return;
  const pon = (id, guardar) => {
    const p = paneles.find(x => x.dataset.q54Panel === id); if (!p) return;
    chips.forEach(c => c.setAttribute('aria-pressed', c.dataset.q54Chip === id ? 'true' : 'false'));
    paneles.forEach(x => { x.hidden = x !== p; });
    if (ambas && p.dataset.ambas) ambas.href = p.dataset.ambas;
    seguir.forEach(a => { if (p.dataset.lectura) a.href = p.dataset.lectura; });
    if (guardar) { try { sessionStorage.setItem('muc:q54:rel', id); } catch (e) {} }
  };
  chips.forEach(c => c.addEventListener('click', () => pon(c.dataset.q54Chip, true)));
  let g = null; try { g = sessionStorage.getItem('muc:q54:rel'); } catch (e) {}
  pon(g && paneles.some(x => x.dataset.q54Panel === g) ? g : chips[0].dataset.q54Chip, false);
})();
/* ==== Q54-5 FIN ==== */
